import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useRecord from '../../../Store/uses/useRecord';
import { NRM_FIRM_STATUS } from '../../../config';

export const useGaranteedBlocs = (recordId) => {
  const history = useHistory();
  const { recordEntity } = useRecord(recordId);
  const active = recordEntity.guaranttedPriceIsActive();
  const guaranteedPrice = useSelector((state) => state.reduxRecords.data[recordId]?.guaranteedPrice || []);
  const firmValuation = useSelector((state) => state.reduxRecords.data[recordId]?.firmValuation || []);
  const nrmStatusId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.nrmStatusId;
  const nrmStatusLabel = useSelector((state) => state.reduxRecords.data[recordId])?.record?.nrmStatusLabel;
  const countryPosId = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.countryId);
  const { validated, confirmed } = NRM_FIRM_STATUS;
  const ncOrder = () => {
    if (firmValuation.length !== 0) {
      const fcoId = firmValuation.filter((item) => item.firmStatusId === confirmed);
      if (fcoId.length !== 0) return fcoId[0].fcoId;
    }
    return null;
  };
  const getValuationPriceByStatus = () => {
    let price = guaranteedPrice?.guaranteeablePrice;
    if (firmValuation.length !== 0) {
      const defaultValuation = firmValuation[firmValuation.length - 1];
      const validatedValuation = firmValuation.filter((item) => item.firmStatusId === validated);
      const confirmedValuation = firmValuation.filter((item) => item.firmStatusId === confirmed);
      price = defaultValuation.firmTTCPrice;
      if (confirmedValuation.length > 0) {
        price = confirmedValuation[0].firmTTCPrice;
      } else if (validatedValuation.length > 0) {
        price = validatedValuation[0].firmTTCPrice;
      }
    }
    return price;
  };
  const gotToGuranteedPrice = () => {
    if (!active) return;
    history.push({
      pathname: `/files/${recordId}/garanteed-price`,
      state: {
        ...history.location.state,
      },
    });
  };
  return {
    gotToGuranteedPrice,
    active,
    guaranteedPrice,
    ncOrder,
    getValuationPriceByStatus,
    nrmStatusId,
    nrmStatusLabel,
    firmValuation,
    countryPosId,
  };
};
